import React from "react";
import { Link } from 'gatsby';

import '../styles/navbar.css';

/** Toggles the submenus given a particular class. */
function toggleSubmenu(e, subClass, isSubMenu = true) {
    const old = Array.from(document.getElementsByClassName('selected'));
    const submenu = Array.from(document.getElementsByClassName(subClass));
    const arrow = e.target.querySelector('ion-icon');
    
    if(isSubMenu === false) {
        old.forEach(node => node.classList.remove('selected'));
        e.target.classList.add('selected');
    }

    submenu.forEach(item => {
        if(item.style.display === 'none') {
            item.style.display = 'block';
        } else {
            item.style.display = 'none';
            if(isSubMenu === false) {
                old.forEach(node => node.classList.remove('selected'));
            }
        }
    });
    arrow.name = arrow.name === 'ios-arrow-forward' ? 'ios-arrow-down' : 'ios-arrow-forward';
}

export default () => <nav className='navbar'>
    {/* Menu */}
	<div className='menu-item' onClick={e => toggleSubmenu(e, 'nav-submenu-1', false)}>
        <ion-icon name='ios-arrow-forward'></ion-icon>
        Getting Started
    </div>
    <div className='menu-subitems nav-submenu-1' style={{ display: 'none' }}>
        <div className='menu-link'>
            <Link to='/about-torchui'>About Torch Design System</Link>
        </div>
        <div className='menu-link'>
            <Link to='/designers-guide'>Designers' Guide</Link>
        </div>
        <div className='menu-link'>
            <Link to='/developers-guide'>Developers' Guide</Link>
        </div>
    </div>


    {/* Menu */}
    <div className='menu-item' onClick={e => toggleSubmenu(e, 'nav-submenu-2', false)}>
        <ion-icon name='ios-arrow-forward'></ion-icon>
        Visual Basics
    </div>
    <div className='menu-subitems nav-submenu-2' style={{ display: 'none' }}>
        <div className='menu-link'>
            <Link to='/vb-typography'>Typography</Link>
        </div>
        <div className='menu-link'>
            <Link to='/vb-icons'>Icons</Link>
        </div>
        <div className='menu-link'>
            <Link to='/vb-grid-and-spacing'>Grid and Spacing</Link>
        </div>
        <div className='menu-link'>
            <Link to='/vb-colors'>Colors</Link>
        </div>
        <div className='menu-link'>
            <Link to='/vb-shadows'>Shadows</Link>
        </div>
    </div>


    {/* Menu */}
    <div className='menu-item' onClick={e => toggleSubmenu(e, 'nav-submenu-3', false)}>
        <ion-icon name='ios-arrow-forward'></ion-icon>
        UI Components
    </div>
    <div className='menu-submenu nav-submenu-3' style={{ display: 'none' }}>
        <div className="menu-submenu-title" onClick={e => toggleSubmenu(e, 'nav-submenu-4')}>
            <ion-icon name='ios-arrow-forward'></ion-icon>
            Navigation
        </div>
        <div className='menu-subitems nav-submenu-4' style={{ display: 'none' }}>
            <div className='menu-link'>
                <Link to='/uic-breadcrumbs'>Breadcrumbs</Link>
            </div>
        </div>
    </div>
    <div className='menu-submenu nav-submenu-3' style={{ display: 'none' }}>
    <div className="menu-submenu-title" onClick={e => toggleSubmenu(e, 'nav-submenu-5')}>
            <ion-icon name='ios-arrow-forward'></ion-icon>
            Notifications
        </div>
        <div className='menu-subitems nav-submenu-5' style={{ display: 'none' }}>
            <div className='menu-link'>
                <Link to='/uic-buttons'>Buttons</Link>
            </div>
            <div className='menu-link'>
                <Link to='/uic-dialogs'>Dialogs</Link>
            </div>
            <div className='menu-link'>
                <Link to='/uic-popovers'>Popovers</Link>
            </div>
            <div className='menu-link'>
                <Link to='/uic-toast'>Toast</Link>
            </div>
            <div className='menu-link'>
                <Link to='/uic-badges'>Badges</Link>
            </div>
            <div className='menu-link'>
                <Link to='/uic-tooltips'>Tooltips</Link>
            </div>
            <div className='menu-link'>
                <Link to='/uic-indicators'>Indicators</Link>
            </div>
        </div>
    </div>
    <div className='menu-submenu nav-submenu-3' style={{ display: 'none' }}>
        <div className="menu-submenu-title" onClick={e => toggleSubmenu(e, 'nav-submenu-6')}>
            <ion-icon name='ios-arrow-forward'></ion-icon>
            Selection
        </div>
        <div className='menu-subitems nav-submenu-6' style={{ display: 'none' }}>
            <div className='menu-link'>
                <Link to='/uic-checkbox'>Checkbox</Link>
            </div>
            <div className='menu-link'>
                <Link to='/uic-radio-buttons'>Radio Buttons</Link>
            </div>
            <div className='menu-link'>
                <Link to='/uic-switch'>Switch</Link>
            </div>
        </div>
    </div>
    <div className='menu-submenu nav-submenu-3' style={{ display: 'none' }}>
        <div className="menu-submenu-title" onClick={e => toggleSubmenu(e, 'nav-submenu-7')}>
            <ion-icon name='ios-arrow-forward'></ion-icon>
            Data Input
        </div>
        <div className='menu-subitems nav-submenu-7' style={{ display: 'none' }}>
            <div className='menu-link'>
                <Link to='/uic-pills'>Pills</Link>
            </div>
            <div className='menu-link'>
                <Link to='/uic-text-area'>Text Area</Link>
            </div>
            <div className='menu-link'>
                <Link to='/uic-text-fields'>Text Fields</Link>
            </div>
            <div className='menu-link'>
                <Link to='/uic-search'>Search</Link>
            </div>
            <div className='menu-link'>
                <Link to='/uic-drop-down'>Drop-Down</Link>
            </div>
            <div className='menu-link'>
                <Link to='/uic-date-pickers'>Date Pickers</Link>
            </div>
            <div className='menu-link'>
                <Link to='/uic-sliders'>Sliders</Link>
            </div>
        </div>
    </div>


    {/* Menu */}
    <div className='menu-item' onClick={e => toggleSubmenu(e, 'nav-submenu-8', false)}>
        <ion-icon name='ios-arrow-forward'></ion-icon>
        UI Modules
    </div>
    <div className='menu-submenu nav-submenu-8' style={{ display: 'none' }}>
        <div className="menu-submenu-title" onClick={e => toggleSubmenu(e, 'nav-submenu-9')}>
            <ion-icon name='ios-arrow-forward'></ion-icon>
            Navigation
        </div>
        <div className='menu-subitems nav-submenu-9' style={{ display: 'none' }}>
            <div className='menu-link'>
                <Link to='/uim-headers'>Headers</Link>
            </div>
            <div className='menu-link'>
                <Link to='/uim-side-bars'>Side Bars</Link>
            </div>
            <div className='menu-link'>
                <Link to='/uim-tabs'>Tabs</Link>
            </div>
        </div>
    </div>
    <div className='menu-submenu nav-submenu-8' style={{ display: 'none' }}>
        <div className="menu-submenu-title" onClick={e => toggleSubmenu(e, 'nav-submenu-10')}>
            <ion-icon name='ios-arrow-forward'></ion-icon>
            Data Display
        </div>
        <div className='menu-subitems nav-submenu-10' style={{ display: 'none' }}>
            <div className='menu-link'>
                <Link to='/uim-date-blocks'>Date Blocks</Link>
            </div>
            <div className='menu-link'>
                <Link to='/uim-data-tables'>Data Tables</Link>
            </div>
            <div className='menu-link'>
                <Link to='/uim-data-collections'>Data Collections</Link>
            </div>
        </div>
    </div>

    <hr></hr>
    <button>Updates</button>
    <button>Help</button>
</nav>